/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Pricing of the quote as the validator wants it (comparator path, nothing written).
 * @export
 * @interface SimulerRetarificationResponse
 */
export interface SimulerRetarificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SimulerRetarificationResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {number}
     * @memberof SimulerRetarificationResponse
     */
    prixHt: number;
    /**
     * 
     * @type {number}
     * @memberof SimulerRetarificationResponse
     */
    taxe: number;
    /**
     * 
     * @type {number}
     * @memberof SimulerRetarificationResponse
     */
    sommeFrais: number;
    /**
     * 
     * @type {number}
     * @memberof SimulerRetarificationResponse
     */
    prixTtc: number;
    /**
     * 
     * @type {number}
     * @memberof SimulerRetarificationResponse
     */
    prixClient: number;
    /**
     * 
     * @type {number}
     * @memberof SimulerRetarificationResponse
     */
    commissionCourtier: number;
    /**
     * Values the comparator brought back within the allowed bounds.
     * @type {Array<string>}
     * @memberof SimulerRetarificationResponse
     */
    corrections: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SimulerRetarificationResponse
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the SimulerRetarificationResponse interface.
 */
export function instanceOfSimulerRetarificationResponse(value: object): value is SimulerRetarificationResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('prixHt' in value) || value['prixHt'] === undefined) return false;
    if (!('taxe' in value) || value['taxe'] === undefined) return false;
    if (!('sommeFrais' in value) || value['sommeFrais'] === undefined) return false;
    if (!('prixTtc' in value) || value['prixTtc'] === undefined) return false;
    if (!('prixClient' in value) || value['prixClient'] === undefined) return false;
    if (!('commissionCourtier' in value) || value['commissionCourtier'] === undefined) return false;
    if (!('corrections' in value) || value['corrections'] === undefined) return false;
    return true;
}

export function SimulerRetarificationResponseFromJSON(json: any): SimulerRetarificationResponse {
    return SimulerRetarificationResponseFromJSONTyped(json, false);
}

export function SimulerRetarificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulerRetarificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'prixHt': json['prixHt'],
        'taxe': json['taxe'],
        'sommeFrais': json['sommeFrais'],
        'prixTtc': json['prixTtc'],
        'prixClient': json['prixClient'],
        'commissionCourtier': json['commissionCourtier'],
        'corrections': json['corrections'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function SimulerRetarificationResponseToJSON(json: any): SimulerRetarificationResponse {
    return SimulerRetarificationResponseToJSONTyped(json, false);
}

export function SimulerRetarificationResponseToJSONTyped(value?: SimulerRetarificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'prixHt': value['prixHt'],
        'taxe': value['taxe'],
        'sommeFrais': value['sommeFrais'],
        'prixTtc': value['prixTtc'],
        'prixClient': value['prixClient'],
        'commissionCourtier': value['commissionCourtier'],
        'corrections': value['corrections'],
        'errorMessage': value['errorMessage'],
    };
}

